//APU Calls Utils
import * as authAPI from 'utils/api/auth';
// import { asyncCompleteSignUp  } from 'utils/api/auth';
import { failedApiCallReroute } from 'utils/messages';
import { receiveFormData } from 'state/actions/shared_form_actions';
import { setAuthData, setAuthDataFail } from 'state/actions/session_status';
// import { getAllSites } from 'state/actions/accountState/account_data';
// THUNK Wrappers for API Calls
import { createFormDataWithValidation } from 'state/actions/shared_form_actions';
// utils
import { clearCookies } from 'utils/auth/clearCookies';
import { log } from 'utils/logger';
import { url } from 'utils/urls';
import { batchActions } from "redux-batched-actions";
import { clearAutoLogoutTimer, clearCheckInactivityTimer } from 'utils/auth/manageTimers';


// import action variables
export const CLEAR_ALL_STATES = 'CLEAR_ALL_STATES';
export const SET_AUTH_TOKEN_DATA = 'SET_AUTH_TOKEN_DATA';

// ACTIONS
export const clearAllStates = () => ({
    type: CLEAR_ALL_STATES
});
export const setAuthTokenData = data => ({
    type: SET_AUTH_TOKEN_DATA,
    data
});

// THUNKS
export const signOut = () => dispatch => {
    clearUserSessionData(dispatch);
    // clear the timers on logout
    clearAutoLogoutTimer();
    clearCheckInactivityTimer();
    return authAPI.userSignOutCall()
        .then(response => log('LOGOUT RESPONSE', response))
        .catch(error => log('LOGOUT NETWORK ERROR', error))
};
export const unmockUser = () => dispatch => {
    // clear the timers on unmock
    clearAutoLogoutTimer();
    clearCheckInactivityTimer();
    return authAPI.unmockUserCall()
        .then(() => {
                window.location.replace(`${url.embedLogin.unmockRedirect}`);
            },
                error => {
                    log('UNMOCK NETWORK ERROR', error) ||
                    clearUserSessionData(dispatch);
            })
};
export const getUserPermissions = userUUID => dispatch => (
    authAPI.userPermissionsCall(userUUID)
        .then(response => dispatch(batchActions([
            setAuthData(response),
            // receiveFormData('personalInformationForm', response.data) // setting data for myprofile fetch to avoid making a call if user navigates there
        ])))
        .catch(err => {
            if(err.response && err.response.status === 401){
                dispatch(signOut())
            }
            //dispatch these separately because "moveToPage" cannot be batched
            dispatch(setAuthDataFail());
            dispatch(failedApiCallReroute(500));
        })
);
export const getAuthTokenData = tokenUUID => dispatch => (
    authAPI.getAuthTokenDataCall(tokenUUID)
        .then(response =>
            dispatch(getTokenActions(response.data)
        ))
        .catch(error => console.log('GET TOKEN DATA ERROR', error.response))
);
export const extendSession = () => dispatch => {
    return authAPI.userExtendSession();
};
const getTokenActions = (responseData) => (
    responseData.tokenType === 'COMPLETE_SIGN_UP' ? batchActions([
        setAuthTokenData(responseData),
        receiveFormData('completesignup', responseData)
    ]) : setAuthTokenData(responseData)
);
const clearUserSessionData = (dispatch) => {
    clearCookies(['account_uuid', 'user_uuid', 'mocked']);
    dispatch(clearAllStates());
};
// -------------- ++++++++ -------------- START: THUNKS -------------- ++++++++ -------------- //

export const requestDemoWithValidation = (fields, callData, successAction, failAction) =>
    createFormDataWithValidation('requestdemo', fields, authAPI.requestDemoCall, callData, successAction, failAction);

export const signInWithValidation = (fields, callData, successAction, failAction) => {
    return createFormDataWithValidation('signin', fields, authAPI.userSignInCall, callData, successAction, failAction);
};
export const resetPasswordWithValidation = (fields, callData, successAction, failAction) =>
    createFormDataWithValidation('resetpassword', fields, authAPI.userSendResetEmail, callData, successAction, failAction);

export const completeResetWithValidation = (fields, callData, successAction, failAction) => console.log("RESETING") ||
    createFormDataWithValidation('completepasswordreset', fields, authAPI.resetPasswordCall, callData, successAction, failAction);

export const completeSignUpWithValidation = (fields, callData, successAction, failAction) =>
    createFormDataWithValidation('completesignup', fields, authAPI.createUserCall, callData, successAction, failAction);
